import type { PadelGameListItem } from '@/services/padelService';

export function displayTimerMs(
  game: Pick<
    PadelGameListItem,
    | 'timerStatus'
    | 'timerSetNumber'
    | 'timerElapsedMs'
    | 'timerStartedAt'
    | 'serverTime'
    | 'setScores'
    | 'scoringType'
  >,
  setNumber: number,
  clientNow: number,
  clientReceivedAt: number = clientNow
): number {
  const isPoints = game.scoringType !== 'sets';
  const setRow = (game.setScores ?? []).find((s) => s.setNumber === setNumber);
  const runningThisSet =
    game.timerStatus === 'running' && (isPoints || (game.timerSetNumber ?? 1) === setNumber);
  const storedElapsed = isPoints
    ? (game.timerElapsedMs ?? 0)
    : runningThisSet
      ? (setRow?.elapsedMs ?? game.timerElapsedMs ?? 0)
      : (setRow?.elapsedMs ?? 0);

  if (runningThisSet && game.timerStartedAt) {
    const offset = Date.parse(game.serverTime ?? '') - clientReceivedAt;
    const serverNow = Number.isFinite(offset) ? clientNow + offset : clientNow;
    const startedAt = Date.parse(game.timerStartedAt);
    if (!Number.isFinite(startedAt)) return Math.max(0, storedElapsed);
    return Math.max(0, storedElapsed + (serverNow - startedAt));
  }

  return Math.max(0, storedElapsed);
}

export function formatTimerMmSs(ms: number): string {
  const totalSec = Math.floor(Math.max(0, ms) / 1000);
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
